import React from "react";
import { formFieldLabelClassName, formFieldRequiredMarkClassName } from "@config/theme/formControls";

export interface FormFieldLabelProps {
	htmlFor?: string;
	children: React.ReactNode;
	required?: boolean;
	className?: string;
}

const FormFieldLabel: React.FC<FormFieldLabelProps> = ({ htmlFor, children, required, className }) => (
	<label className={className ?? formFieldLabelClassName} htmlFor={htmlFor}>
		{children}
		{required && (
			<>
				{" "}
				<span className={formFieldRequiredMarkClassName}>*</span>
			</>
		)}
	</label>
);

export default FormFieldLabel;
